<template>
        <v-autocomplete
            v-model="selectedItem"
            dense
            outlined
            :items="list"
            placeholder="Grupo Econômico"
            item-text="label"
            item-value="value"
            @change="selectedItem!=null?select(selectedItem):''"
            class="comboClients pl-5"
        ></v-autocomplete>
</template>
<script>
import { mapState } from 'vuex'
export default {
    data() {
        return {
            selectedItem: null
        }
    },
    props:{
        select: Function
    },
    watch: {
        grupoEconomico:{
            deep: true,
            handler(val) {
                this.selectedItem = val
                
            } 
        }
    },
    mounted() {
          this.selectedItem = this.$store.state.permissions.grupoEconomico
    },
    computed: {
        ...mapState({
            grupoEconomico: (state) => state.permissions.grupoEconomico,
            isTradimus: (state) => state.userData.userData.UsuarioTradimus,
            list: (state) => state.permissions.clientsList
        })
    }
}
</script>
<style scoped>
.comboClients {
    max-width: 300px;
}
</style>